module.exports = __webpack_public_path__ + "static/media/moment14.acd51b29.jpg";